import _ from 'lodash';
import { AnyAction } from 'redux';
import { AETierCalculations } from '../../../annual-enrollment/models/annual-enrollment-models';
import { None } from '../../constants/constant-strings';
import { MidYearAction, MidYearEnrollment, MidyearEnrollmentState, MidYearPlanType } from './mid-year-model';

const InitialState: MidyearEnrollmentState = {
	midYearLoaded: false,
	currentMidYearEnrollment: null,
	tierCalculations: null,
};


export const midYearEnrollmentReducer = (state = InitialState, action: AnyAction): MidyearEnrollmentState => {


	switch (action.type) {
		case MidYearAction.SET_MID_YEAR_ENROLLMENT:
			return {
				...state,
				midYearLoaded: true,
				currentMidYearEnrollment: action.payload,

			};

		case MidYearAction.CLEAR_MID_YEAR_STATE:
			return {
				...state,
				midYearLoaded: false,
				currentMidYearEnrollment: null,
				tierCalculations: null,
			};

		case MidYearAction.SET_TIER_CALCULATION:
			return {
				...state,
				tierCalculations: {
					...state.tierCalculations,
					[action.planType]: action.payload,
				},
			};

		default: return state;
	}
};

const getEmptyEnrollment = () => {
	return {
		account_nbr: None,
		code: None,
		effective_date: '',
		group_id: '',
		name: '',
		policy_nbr: '',
		rate: '',
		termination_date: '',
		tier: null,
		volume: '',
	};
};


export const setMidYearEnrollment = (midYear: MidYearEnrollment) => {

	//so I dont need to check those undefined arrays..
	const copy = _.cloneDeep(midYear);
	if (copy?.enrollments_base) {
		if (!copy?.enrollments_base?.D) copy.enrollments_base.D = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.M) copy.enrollments_base.M = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.G) copy.enrollments_base.G = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.S) copy.enrollments_base.S = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.L) copy.enrollments_base.L = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.P) copy.enrollments_base.P = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.U) copy.enrollments_base.U = [getEmptyEnrollment()];
		if (!copy?.enrollments_base?.W) copy.enrollments_base.W = [getEmptyEnrollment()];
	}
	return {
		type: MidYearAction.SET_MID_YEAR_ENROLLMENT,
		payload: copy,

	};
};

export const clearMidYearState = () => {
	return {
		type: MidYearAction.CLEAR_MID_YEAR_STATE,
	};
};

export const setMYCalcTiers = (calcTiers: AETierCalculations, planType: MidYearPlanType) => {
	return {
		type: MidYearAction.SET_TIER_CALCULATION,
		payload: calcTiers,
		planType,
	};
};
